/**
 * Create Support Ticket context for custom hook
 */

import { createContext } from 'react'

const BackInStockNotificationsContext = createContext({
  createBackInStockNotifications: () => {},
  deleteBackInStockNotifications: () => {},
  fetchBackInStockNotifications: () => {},
})

export default BackInStockNotificationsContext
